import type { SchemaObjectsArrayInputMetadata } from '@newfront-insurance/coverage-api';
import type { CustomValue, SchemaFieldType } from '@newfront-insurance/dsl-schema-ui';
import { getStringifiedFieldValue } from '@newfront-insurance/dsl-schema-ui';

export type SchemaObjectsArrayValue = Record<string, unknown>[] | undefined;

export const SchemaObjectsArrayDisplay: CustomValue<SchemaObjectsArrayValue, SchemaObjectsArrayInputMetadata> = ({
  field,
  value,
}) => {
  // Use the stringifier to display the values
  const displayValue = getStringifiedFieldValue(value, field as SchemaFieldType);

  return <div className="whitespace-pre-wrap">{displayValue || '-'}</div>;
};
